import { Component, OnInit, Input } from '@angular/core'
import { DvmFeedbackRow } from '../../models/dvm-row'

@Component({
   selector: 'vc-dvm-feedback-row',
   templateUrl: './dvm-feedback-row.component.html',
   styleUrl: './dvm-feedback-row.component.scss',
   standalone: false,
})
export class DVMFeedbackRowComponent implements OnInit {
   @Input() rowData: DvmFeedbackRow
   @Input() maxLength: number

   ngOnInit(): void {}

   handleSelectionChanged(event: any, i: number) {
      this.rowData.selectedItems[i] = event
   }

   dropdowns() {
      return new Array(this.rowData.dropdowns).fill(null)
   }
}
